import React from 'react'
import SvgIcon from './SvgIcon'

export default function RubleLightIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 15 17">
      <path 
        fillRule="evenodd"
        d="M2 13V17H3V13H7V12H3V10H9.5C9.5 10 14.5 10 14.5 5C14.5 0 9.5 0 9.5 0H2V9H0V10H2V12H0V13H2ZM9.5 9H3V1H9.5C9.5 1 13.5 1 13.5 5C13.5 9 9.5 9 9.5 9Z"/>
      <path 
        fillRule="evenodd"
        d="M9.5 0H2V9H0V10H2V12H0V13H2V17H3V13H7V12H3V10H9.5C9.5 10 14.5 10 14.5 5C14.5 0 9.5 0 9.5 0ZM3 9V1H9.5C9.5 1 13.5 1 13.5 5C13.5 9 9.5 9 9.5 9H3Z"/>

    </SvgIcon>
  )
}

RubleLightIcon.displayName = 'RubleLightIcon'
